module.exports = __webpack_public_path__ + "img/code.56b734bf.svg";